import {SidebarDispatcher} from '../core/dispatchers'
import {ISidebarDispatcher} from '../core/interfaces/dispatchers'

class AppSidebarDispatcher extends SidebarDispatcher {}

export const appSidebarDispatcher = new AppSidebarDispatcher() as ISidebarDispatcher
